import React, { useEffect } from "react";
// import NewlettersData from '../components/NewslettersData'
import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


function Newsletter() {

    const location = useLocation();
    
      // Scroll to the section if specified in the URL state
      useEffect(() => {
        if (location.state?.scrollTo) {
          const element = document.getElementById(location.state.scrollTo);
          if (element) {
            // Use smooth scrolling to the section
            element.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, [location]);


  const tabs = [
    { title: 'IBPYP', content: () => <div>
    
    <div className='cam-lower-sec'>
    <h1 id="SanskarNewsletter" className='title'>IBPYP</h1>
    </div>
    <div className='newsletter-sec-row'>
      <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/Sep-Vol-18.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibpyp/2026/Sep-Vol-18.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBPYP Newsletter</p>
          <p> September 2026 Volume 18</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/Newsletter_Volume_17.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibpyp/2026/Mar-Vol-17.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBPYP Newsletter</p>
          <p>March 2026 Volume 17</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/September-2025-V-16.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibpyp/2025/sep-vol-16.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBPYP Newsletter</p>
          <p>September 2025 Volume 16</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/March-2025-V-15.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibpyp/2025/vol-15.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBPYP Newsletter</p>
          <p>March 2025 Volume 15</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/august-2024-v-14.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibpyp/2023/vol-14.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBPYP Newsletter</p>
          <p>August 2024 Volume 14</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBPYP/November-2023-v-13.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibpyp/2023/mar-vol-13.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBPYP Newsletter</p>
          <p>November 2023 Volume 13</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBPYP/November-2023-v-12.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibpyp/2023/nov-vol-12.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBPYP Newsletter</p>
          <p>November 2023 Volume 12</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBPYP/July-2023-v-11.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibpyp/2023/jul-vol-11.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBPYP Newsletter</p>
          <p>July 2023 Volume 11</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBPYP/March-2023-v-10.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibpyp/2023/mar-vol-10.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBPYP Newsletter</p>
          <p>March 2023 Volume 10</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBPYP/November-2022-v-9.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibpyp/2022/nov-vol-9.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBPYP Newsletter</p>
          <p>November 2022 Volume 9</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBPYP/July-2022-v-8.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibpyp/2022/jul-vol-8.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBPYP Newsletter</p>
          <p>July 2022 Volume 8</p>
        </div>
        </Link>
      </div>
        <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/March-2022-v-7.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/ibpyp/2022/mar-vol-7.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
            <p>IBPYP Newsletter</p>
            <p>March 2022 Volume 7</p>
          </div>
          </Link>
        </div>
        <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/November-2021-v-2.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/ibpyp/2021/nov-vol-2.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
            <p>IBPYP Newsletter</p>
            <p>November 2021 Volume 6</p>
          </div>
          </Link>
        </div>
        <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/July-2021-v-5.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/ibpyp/2021/jul-vol-1.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
            <p>IBPYP Newsletter</p>
            <p>July 2021 Volume 5</p>
          </div>
          </Link>
        </div>
        <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/March-2023-v-4.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/ibpyp/2021/mar-vol-4.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
            <p>IBPYP Newsletter</p>
            <p>March 2021 Volume 4</p>
          </div>
          </Link>
        </div>
        <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/december-2020-v-3.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/ibpyp/2020/dec-vol-3.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
            <p>IBPYP Newsletter</p>
            <p>December 2020 Volume 3</p>
          </div>
          </Link>
        </div>
        <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/august-2020-v-2.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/ibpyp/2020/aug-vol-2.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
            <p>IBPYP Newsletter</p>
            <p>August 2020 Volume 2</p>
          </div>
          </Link>
        </div>
        <div className='newletter-box'>
        <Link to="../newsletter/IBPYP/may-2020-v-1.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/ibpyp/2020/may-vol-1.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
            <p>IBPYP Newsletter</p>
            <p>May 2020 Volume 1</p>
          </div>
          </Link>
        </div>
    </div>



  

    </div> },
     { title: 'CIE', content: () => <div>
    
     <div className='cam-lower-sec'>
     <h1 className='title'>CAIE</h1>
     </div>
     <div className='newsletter-sec-row'>
      <div className='newletter-box'>
      <Link to="../newsletter/CAIE/E-NEWSLETTER _AUGUST_2026.pdf"
          target="_blank"
          rel="noopener noreferrer">
        <div className='newletter-img'>
          <img src="../img/newsletter/caie/2026/vol-13.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>CIE Newsletter</p>
          <p>August 2026 Volume 13</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/CAIE/E-NEWSLETTER_VOL 12.pdf"
          target="_blank"
          rel="noopener noreferrer">
        <div className='newletter-img'>
          <img src="../img/newsletter/caie/2026/vol-12.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>CIE Newsletter</p>
          <p>March 2026 Volume 12</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/CAIE/E-NEWSLETTER_VOL 11.pdf"
          target="_blank"
          rel="noopener noreferrer">
        <div className='newletter-img'>
          <img src="../img/newsletter/caie/2025/vol-11.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>CIE Newsletter</p>
          <p>August 2025 Volume 11</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/CAIE/CAIE Newsletter 2025 Volume 10.pdf"
          target="_blank"
          rel="noopener noreferrer">
        <div className='newletter-img'>
          <img src="../img/newsletter/caie/2025/vol-10.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>CIE Newsletter</p>
          <p>March 2025 Volume 10</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/CAIE/CAIE Newsletter 2023 Volume 9.pdf"
          target="_blank"
          rel="noopener noreferrer">
        <div className='newletter-img'>
          <img src="../img/newsletter/caie/2023/vol-9.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>CIE Newsletter</p>
          <p>November 2024 Volume 9</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/CAIE/CAM Aug 2023 Vol-8.pdf"
          target="_blank"
          rel="noopener noreferrer">
        <div className='newletter-img'>
          <img src="../img/newsletter/caie/2023/aug-vol-8.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>CIE Newsletter</p>
          <p>August 2023 Volume 8</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/CAIE/CAM Mar 2023 Vol-7.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/caie/2022/mar-vol-7.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>CIE Newsletter</p>
          <p>March 2023 Volume 7</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/CAIE/CAM Aug 2022 Vol-6.pdf"
          target="_blank"
          rel="noopener noreferrer">  
        <div className='newletter-img'>
          <img src="../img/newsletter/caie/2022/aug-vol-6.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
        <p>CIE Newsletter</p>
          <p>August 2022 Volume 6</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/CAIE/CAM Mar 2022 Vol-5.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/caie/2022/mar-vol-5.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
        <p>CIE Newsletter</p>
          <p>March 2022 Volume 5</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/CAIE/CAM Nov 2021 Vol-4.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/caie/2021/nov-vol-4.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
        <p>CIE Newsletter</p>
          <p>November 2021 Volume 4</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/CAIE/CAM Aug 2021 Vol-3.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/caie/2021/aug-vol-3.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
        <p>CIE Newsletter</p>
          <p>August 2021 Volume 3</p>
        </div>
        </Link>
      </div>
        <div className='newletter-box'>
        <Link to="../newsletter/CAIE/CAIE Oct 2020 Volume 2.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/caie/2020/oct-vol-3.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
          <p>CIE Newsletter</p>
            <p>October 2020 Volume 2</p>
          </div>
          </Link>
        </div>
        <div className='newletter-box'>
        <Link to="../newsletter/CAIE/CAM Jun 2021 Vol-1.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/caie/2020/jun-vol-1.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
          <p>CIE Newsletter</p>
            <p>June 2020 Volume 1</p>
          </div>
          </Link>
        </div>
  
    </div>
 
 
 
   
 
     </div> },
     { title: 'IBDP', content: () => <div>
    
          <div className='cam-lower-sec'>
          <h1 className='title'>IBDP</h1>
          </div>
          <div className='newsletter-sec-row'>
      <div className='newletter-box'>
      <Link to="../newsletter/IBDP/IBDP March 2026 Vol-14.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibdp/2026/mar-vol-14.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBDP Newsletter</p>
          <p>September 2025 Volume 13</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBDP/IBDP September 2025 Vol-13.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibdp/2025/sep-vol-13.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBDP Newsletter</p>
          <p>September 2025 Volume 13</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBDP/IBDP Mar 2025 Vol-12.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibdp/2025/mar-vol-12.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBDP Newsletter</p>
          <p>March 2025 Volume 12</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBDP/IBDP Newsletter Volume 11.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibdp/2024/jan-vol-11.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBDP Newsletter</p>
          <p>November 2024 Volume 11</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBDP/IBDP Jan 2024 Vol-10.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibdp/2024/jan-vol-10.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBDP Newsletter</p>
          <p>January 2024 Volume 10</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBDP/IBDP Aug 2023 Vol-9.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibdp/2023/aug-vol-9.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBDP Newsletter</p>
          <p>August 2023 Volume 9</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBDP/IBDP Feb 2023 Vol-8.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibdp/2023/feb-vol-8.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBDP Newsletter</p>
          <p>February 2023 Volume 8</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBDP/IBDP Aug 2022 Vol-7.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibdp/2022/aug-vol-7.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBDP Newsletter</p>
          <p>August 2022 Volume 7</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBDP/IBDP Mar 2022 Vol-6.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
          <img src="../img/newsletter/ibdp/2022/mar-vol-6.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBDP Newsletter</p>
          <p>March 2022 Volume 6</p>
        </div>
        </Link>
      </div>
      <div className='newletter-box'>
      <Link to="../newsletter/IBDP/IBDP Nov 2021 Vol-5.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
        <div className='newletter-img'>
        <img src="../img/newsletter/ibdp/2021/nov-vol-5.webp" alt="" />
        </div>
        <div className='newsletter-heading'>
          <p>IBDP Newsletter</p>
          <p>November 2021 Volume 5</p>
        </div>
        </Link>
      </div>
        <div className='newletter-box'>
        <Link to="../newsletter/IBDP/IBDP Aug 2021 Vol-4.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
          <img src="../img/newsletter/ibdp/2021/aug-vol-4.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
            <p>IBDP Newsletter</p>
            <p>August 2021 Volume 4</p>
          </div>
          </Link>
        </div>
        <div className='newletter-box'>
        <Link to="../newsletter/IBDP/IBDP Jan 2021 Vol-3.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/ibdp/2021/jan-vol-3.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
            <p>IBDP Newsletter</p>
            <p>January 2021 Volume 3</p>
          </div>
          </Link>
        </div>
        <div className='newletter-box'>
        <Link to="../newsletter/IBDP/IBDP Sep 2020 Vol-2.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/ibdp/2020/sep-vol-2.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
            <p>IBDP Newsletter</p>
            <p>September 2020 Volume 2</p>
          </div>
          </Link>
        </div>
        <div className='newletter-box'>
        <Link to="../newsletter/IBDP/IBDP Jun 2020 Vol-1.pdf"
          target="_blank"
          rel="noopener noreferrer"> 
          <div className='newletter-img'>
            <img src="../img/newsletter/ibdp/2020/jun-vol-1.webp" alt="" />
          </div>
          <div className='newsletter-heading'>
            <p>IBDP Newsletter</p>
            <p>June 2020 Volume 1</p>
          </div>
          </Link>
        </div>
  
    </div>
      
          </div> },
  
  ]
  return (
    <div>
     <div className='ibdp-hero-sec'>
        <img src='../newimg/infa5.webp'/>

      </div>
      <div className="newsletter-sec">
      <HorizontalTabs tabs={tabs} />
      </div>


    </div>
  )
}

export default Newsletter;
